import axios from "./interceptors";
import { IGenericResponse, IRequestParams } from "@/services/interfaces";
import { newSaleChecker } from "./newSaleChecker";
import { AxiosError } from "axios";

export default async ({
  url,
  method,
  data,
  params,
}: IRequestParams): Promise<IGenericResponse> => {
  const request: any = {
    url,
    method,
  };
  if (method === "GET") request.params = params;
  else request.data = data;

  try {
    const res = await axios(request);
    newSaleChecker(res.data?.meta);
    return {
      data: res.data,
      status: res.status,
      errors: null,
    };
  } catch (err) {
    const Error = err as AxiosError;
    if (Error.response) {
      return {
        data: null,
        errors: Error.response.data.errors,
        status: Error.response.status,
      };
    } else {
      return {
        data: null,
        errors: { fetch: ["При обращении к серверу произошел сбой"] },
        status: 500,
      };
    }
  }
};
